// DO NOT MODIFY
// This code is generated by https://github.rbx.com/Roblox/activity-history-event-generation
// Please put in <TODD> and create a new pull request
// DO NOT MODIFY
export enum EventType {
  Unknown = -1,
  // Begin Generated Code 🤖
  Init = 0,
  ArchivedExperience = 1,
  PlayabilityChanged = 2,
  NotificationStringCreated = 3,
  NotificationStringDeleted = 4,
  NotificationStringUpdated = 5,
  AvatarSettingsAvatarType = 6,
  AvatarSettingsAnimation = 7,
  AvatarSettingsCollision = 8,
  AvatarSettingsScaleHeight = 9,
  AvatarSettingsScaleWidth = 10,
  AvatarSettingsScaleHead = 11,
  AvatarSettingsScaleBodyType = 12,
  AvatarSettingsScaleProportions = 13,
  AvatarSettingsBodyParts = 14,
  AvatarSettingsClothing = 15,
  ExperienceName = 16,
  ExperienceDescription = 17,
  ExperienceGenre = 18,
  SecuritySettingsHTTPRequests = 19,
  SecuritySettingsStudioAccessToAPI = 20,
  SecuritySettingsThirdPartySales = 21,
  SecuritySettingsThirdPartyTeleports = 22,
  ExperienceShutDown = 23,
  SocialLinksAdded = 24,
  SocialLinksRemoved = 25,
  SocialLinksUpdated = 26,
  SpatialVoice = 27,
  WorldSettingsWorkSpaceGravity = 28,
  WorldSettingsJumpHeight = 29,
  WorldSettingsJumpPower = 30,
  WorldSettingsWalkSpeed = 31,
  WorldSettingsMaxSlopeAngle = 32,
  SentUpdate = 33,
  SupportedLanguages = 34,
  AutoTranslationExperienceInformation = 35,
  AutoTranslationExperienceStringsAndProducts = 36,
  LocalizationSettingsAutomaticTextCapture = 37,
  LocalizationSettingsUserTranslatedContent = 38,
  ClearUnmodifiedAutoCaptureEntries = 39,
  AnalyticsReport = 40,
  TranslationIconAdded = 41,
  TranslationIconDeleted = 42,
  TranslationExperienceName = 43,
  TranslationExperienceDescription = 44,
  TranslationThumbnailAltText = 45,
  TranslationThumbnailAdded = 46,
  TranslationThumbnailDeleted = 47,
  TranslationThumbnailOrder = 48,
  TranslationStringAdded = 49,
  TranslationStringDeleted = 50,
  TranslationStringUpdated = 51,
  TranslationBadgeIconDeleted = 52,
  TranslationBadgeDescription = 53,
  TranslationBadgeIconAdded = 54,
  TranslationBadgeName = 55,
  TranslationDeveloperProductIconDeleted = 56,
  TranslationDeveloperProductDescription = 57,
  TranslationDeveloperProductIconAdded = 58,
  TranslationDeveloperProductName = 59,
  TranslationGamePassIconDeleted = 60,
  TranslationGamePassDescription = 61,
  TranslationGamePassIconAdded = 62,
  TranslationGamePassName = 63,
  UserTranslator = 64,
  GroupTranslator = 65,
  ExperienceAdvertisement = 66,
  MonetizationSettingsAccessType = 67,
  MonetizationSettingsRequiresRobux = 68,
  MonetizationSettingsRobuxPrice = 69,
  MonetizationSettingsPlayableDevices = 70,
  MonetizationSettingsAllowPrivateServers = 71,
  MonetizationSettingsPrivateServerPrice = 72,
  ExperienceSponsor = 73,
  BadgeName = 74,
  BadgeDescription = 75,
  BadgeIcon = 76,
  BadgeCreate = 77,
  DeveloperProductName = 78,
  DeveloperProductDescription = 79,
  DeveloperProductIcon = 80,
  DeveloperProductPrice = 81,
  DeveloperProductCreate = 82,
  GamePassName = 83,
  GamePassDescription = 84,
  GamePassIcon = 85,
  GamePassPrice = 86,
  GamePassCreate = 87,
  PermissionsUserAdded = 88,
  PermissionsGroupAdded = 89,
  PermissionsUserChanged = 90,
  PermissionsUserRemoved = 91,
  PermissionsGroupChanged = 92,
  PermissionsGroupRemoved = 93,
  TeamCreate = 94,
  PlaceIconAutoGenerated = 95,
  PlaceIconChanged = 96,
  PlaceIconRemoved = 97,
  PlaceGearGenresOnlyAllowFromExperiencesGenre = 98,
  PlaceGearGenresAllowAllGearGenres = 99,
  PlaceGearTypes = 100,
  PlaceDownloadPermission = 101,
  PlaceGenre = 102,
  PlaceName = 103,
  PlaceDescription = 104,
  PlaceMaxVisitorCount = 105,
  PlaceSocialSlotsRobloxOptimized = 106,
  PlaceSocialSlotsDisabled = 107,
  PlaceSocialSlotsCustomize = 108,
  PlacePermissionsCreatePlaceAPI = 109,
  PlacePermissionsSavePlaceAPI = 110,
  PlaceRevert = 111,
  PlaceShutDown = 112,
  PlaceRestart = 113,
  PlaceThumbnailAltText = 114,
  PlaceThumbnailAdded = 115,
  PlaceThumbnailOrder = 116,
  PlaceThumbnailDeleted = 117,
  PlaceAdded = 118,
  PlaceRemoved = 119,
  PlacePublished = 120,
  CompletedQuestionnaire = 121,
  MonetizationSettingsPrivateServerRequiresRobux = 122,
  SecuritySettingsEditableMeshAndTextureAPIAccess = 123,
  PackagePublish = 124,
  PackageManualUpdate = 125,
  PackageAutoUpdate = 126,
  PackageAutoUpdateToggle = 127,
  RoleCreated = 128,
  RoleDeleted = 129,
  RolePermissionsUpdated = 130,
  RoleNameUpdated = 131,
  MemberRemoved = 132,
  MemberInvited = 133,
  InviteRevoked = 134,
  MemberJoined = 135,
  RoleAssigned = 136,
  RoleUnassigned = 137,
  GroupIconUpdated = 138,
  GroupNameUpdated = 139,
  GroupDescriptionUpdated = 140,
  GroupSocialLinksUpdated = 141,
  GroupOwnerUpdated = 142,
  OneTimePayoutSent = 143,
  PayoutsConfigured = 144,
  DraftCommit = 145,
  ExperiencePermissionsUpdated = 146,
  ExperienceCreated = 147,
  AdCreated = 148,
  PlaceModerated = 149,
  AssetModerated = 150,
  // End of Generated Code 🤖
  // INSERT CODE HERE 1 ☝️
}

export enum ResourceType {
  Universe = 0,
  Place = 1,
  User = 2,
  Badge = 3,
  DeveloperProduct = 4,
  GamePass = 5,
  Group = 6,
  Robux = 7,
  Asset = 8,
}

export enum Categories {
  ExperienceConfiguration = 'Experience Configuration',
  Localization = 'Localization',
  Permissions = 'Permissions',
  PlaceConfiguration = 'Place Configuration',
  PlacePublish = 'Place Publish',
  Content = 'Content',
}

export const categoriesToTranslationKey: Record<Categories, string> = {
  [Categories.ExperienceConfiguration]: 'Label.ExperienceConfiguration',
  [Categories.Localization]: 'Label.FilterOptionLocalization',
  [Categories.Permissions]: 'Label.FilterOptionPermissions',
  [Categories.PlaceConfiguration]: 'Label.FilterOptionPlaceConfiguration',
  [Categories.PlacePublish]: 'Label.FilterOptionPlacePublish',
  [Categories.Content]: 'Label.FilterOptionContent',
};

export const allCategoriesEnums: Categories[] = [
  Categories.ExperienceConfiguration,
  // TODO: Uncomment for https://roblox.atlassian.net/browse/COLLAB-5304
  // Categories.Localization,
  Categories.Permissions,
  Categories.PlaceConfiguration,
  Categories.PlacePublish,
  Categories.Content,
];

export const categoryEventMapping: { [key in Categories]: EventType[] } = {
  // Begin Generated Code 🤖
  [Categories.ExperienceConfiguration]: [
    EventType.ArchivedExperience,
    EventType.PlayabilityChanged,
    EventType.NotificationStringCreated,
    EventType.NotificationStringDeleted,
    EventType.NotificationStringUpdated,
    EventType.AvatarSettingsAvatarType,
    EventType.AvatarSettingsAnimation,
    EventType.AvatarSettingsCollision,
    EventType.AvatarSettingsScaleHeight,
    EventType.AvatarSettingsScaleWidth,
    EventType.AvatarSettingsScaleHead,
    EventType.AvatarSettingsScaleBodyType,
    EventType.AvatarSettingsScaleProportions,
    EventType.AvatarSettingsBodyParts,
    EventType.AvatarSettingsClothing,
    EventType.ExperienceName,
    EventType.ExperienceDescription,
    EventType.ExperienceGenre,
    EventType.SecuritySettingsHTTPRequests,
    EventType.SecuritySettingsStudioAccessToAPI,
    EventType.SecuritySettingsThirdPartySales,
    EventType.SecuritySettingsThirdPartyTeleports,
    EventType.ExperienceShutDown,
    EventType.SocialLinksAdded,
    EventType.SocialLinksRemoved,
    EventType.SocialLinksUpdated,
    EventType.SpatialVoice,
    EventType.WorldSettingsWorkSpaceGravity,
    EventType.WorldSettingsJumpHeight,
    EventType.WorldSettingsJumpPower,
    EventType.WorldSettingsWalkSpeed,
    EventType.WorldSettingsMaxSlopeAngle,
    EventType.SentUpdate,
    EventType.ExperienceAdvertisement,
    EventType.MonetizationSettingsAccessType,
    EventType.MonetizationSettingsRequiresRobux,
    EventType.MonetizationSettingsRobuxPrice,
    EventType.MonetizationSettingsPlayableDevices,
    EventType.MonetizationSettingsAllowPrivateServers,
    EventType.MonetizationSettingsPrivateServerPrice,
    EventType.ExperienceSponsor,
    EventType.BadgeName,
    EventType.BadgeDescription,
    EventType.BadgeIcon,
    EventType.BadgeCreate,
    EventType.DeveloperProductName,
    EventType.DeveloperProductDescription,
    EventType.DeveloperProductIcon,
    EventType.DeveloperProductPrice,
    EventType.DeveloperProductCreate,
    EventType.GamePassName,
    EventType.GamePassDescription,
    EventType.GamePassIcon,
    EventType.GamePassPrice,
    EventType.GamePassCreate,
    EventType.CompletedQuestionnaire,
    EventType.MonetizationSettingsPrivateServerRequiresRobux,
    EventType.SecuritySettingsEditableMeshAndTextureAPIAccess,
    EventType.PayoutsConfigured,
    EventType.AdCreated,
  ],
  [Categories.Localization]: [
    EventType.SupportedLanguages,
    EventType.AutoTranslationExperienceInformation,
    EventType.AutoTranslationExperienceStringsAndProducts,
    EventType.LocalizationSettingsAutomaticTextCapture,
    EventType.LocalizationSettingsUserTranslatedContent,
    EventType.TranslationIconAdded,
    EventType.TranslationIconDeleted,
    EventType.TranslationExperienceName,
    EventType.TranslationExperienceDescription,
    EventType.TranslationThumbnailAltText,
    EventType.TranslationThumbnailAdded,
    EventType.TranslationThumbnailDeleted,
    EventType.TranslationStringAdded,
    EventType.TranslationStringDeleted,
    EventType.TranslationStringUpdated,
    EventType.TranslationBadgeIconDeleted,
    EventType.TranslationBadgeDescription,
    EventType.TranslationBadgeIconAdded,
    EventType.TranslationBadgeName,
    EventType.TranslationDeveloperProductIconDeleted,
    EventType.TranslationDeveloperProductDescription,
    EventType.TranslationDeveloperProductIconAdded,
    EventType.TranslationDeveloperProductName,
    EventType.TranslationGamePassIconDeleted,
    EventType.TranslationGamePassDescription,
    EventType.TranslationGamePassIconAdded,
    EventType.TranslationGamePassName,
    EventType.UserTranslator,
    EventType.GroupTranslator,
  ],
  [Categories.Permissions]: [
    EventType.PermissionsUserAdded,
    EventType.PermissionsGroupAdded,
    EventType.PermissionsUserChanged,
    EventType.PermissionsUserRemoved,
    EventType.PermissionsGroupChanged,
    EventType.PermissionsGroupRemoved,
    EventType.TeamCreate,
    EventType.ExperiencePermissionsUpdated,
  ],
  [Categories.PlaceConfiguration]: [
    EventType.PlaceIconAutoGenerated,
    EventType.PlaceIconChanged,
    EventType.PlaceIconRemoved,
    EventType.PlaceGearGenresOnlyAllowFromExperiencesGenre,
    EventType.PlaceGearGenresAllowAllGearGenres,
    EventType.PlaceGearTypes,
    EventType.PlaceDownloadPermission,
    EventType.PlaceGenre,
    EventType.PlaceName,
    EventType.PlaceDescription,
    EventType.PlaceMaxVisitorCount,
    EventType.PlaceSocialSlotsRobloxOptimized,
    EventType.PlaceSocialSlotsDisabled,
    EventType.PlaceSocialSlotsCustomize,
    EventType.PlacePermissionsCreatePlaceAPI,
    EventType.PlacePermissionsSavePlaceAPI,
    EventType.PlaceRevert,
    EventType.PlaceShutDown,
    EventType.PlaceRestart,
    EventType.PlaceThumbnailAltText,
    EventType.PlaceThumbnailAdded,
    EventType.PlaceThumbnailDeleted,
  ],
  [Categories.PlacePublish]: [
    EventType.PlaceAdded,
    EventType.PlaceRemoved,
    EventType.PlacePublished,
  ],
  [Categories.Content]: [
    EventType.ExperienceCreated,
    EventType.PlaceModerated,
    EventType.AssetModerated,
  ],
  // End of Generated Code 🤖
  // INSERT CODE HERE 2 ☝️
};

export enum ExperiencePlayability {
  Public = 'Public',
  Private = 'Private',
  Friends = 'Friends',
}

export const playabilityTranslationKeys: {
  [key in ExperiencePlayability]: string;
} = {
  [ExperiencePlayability.Private]: 'Description.ActionPrivate',
  [ExperiencePlayability.Public]: 'Description.ActionPublic',
  [ExperiencePlayability.Friends]: 'Description.ActionConnections',
};

// All events where an additional username needs to be fetched (given by the event's resourceId)
export const usernameEvents: Set<EventType> = new Set([
  EventType.UserTranslator,
  EventType.PermissionsUserAdded,
  EventType.PermissionsUserChanged,
  EventType.PermissionsUserRemoved,
  EventType.MemberRemoved,
  EventType.MemberInvited,
  EventType.InviteRevoked,
  EventType.MemberJoined,
  EventType.RoleAssigned,
  EventType.RoleUnassigned,
]);
